export const style = {
  row: {
    border: `1px solid transparent`,
    borderBottom: `1px solid #666`,
    ':hover': {
      border: `1px solid #666`,
      background: `#fbfbfb`
    }
  },
  header: {
    borderBottom: `1px solid #666`
  },
  button: {
    border: `1px solid #666`,
    background: `#fbfbfb`
  },
  searchInput: {
    border: `1px solid #666`
  },
  counter: {
    // fontWeight: `600`,
    color: `#A94545`
  },
  datetime: {
    color: `black`
  },
  time: {
    color: `black`
  },
  date: {
    color: `black`
  },
  category: {
    color: `black`
  },
  author: {
    color: `black`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/ColorBlind/table.js